/**
 * react-validation textarea wrapper
 */

// deps
import PropTypes from 'prop-types';

export default class CustomTextarea extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    wrapperClass: PropTypes.string,
    isRequired: PropTypes.bool
  };

  static defaultProps = {
    wrapperClass: '',
    displayCharacterCount: false,
    maxLength: 0,
    isRequired: false
  };

  constructor(props) {
    super(props);

    this.state = {
      characterCount: this.props.maxLength
    };
  }

  _renderCharacterCounter = () => {
    return (
      <div className="textarea-character-count">
        {`${this.state.characterCount} characters left`}
      </div>
    );
  }

  _updateCharacterCount = (event) => this.setState({ characterCount: parseInt(this.props.maxLength, 10) - event.target.value.length });

  render() {
    return (
      <div className={`${this.props.wrapperClass} control-wrapper`}>
        <textarea
          name={ this.props.name }
          id={ this.props.id }
          maxLength={ this.props.maxLength }
          onChange={ this._updateCharacterCount }
          required={ this.props.isRequired }
        />
        {
          this.props.displayCharacterCount && this._renderCharacterCounter()
        }
      </div>
    );
  }
}
